import React from 'react'

import Table from '../UI/Table/Table'
import { withTranslate } from 'react-redux-multilingual'

const DataTable = ({
  data,
  structure,
  tableTitle,
  rowActions,
  pagination,
  pageChange,
  perPageChange,
  loading,
  translate,
  paginationDisabled,
  errorText,
  localization = {
    header: {
      actions: translate('action')
    },
    toolbar: {
      searchTooltip: translate('search'),
      searchPlaceholder: translate('search')
    }
  },
  options
}) => {
  return (
    <Table
      loading={loading}
      structure={structure}
      recordData={data}
      rowActions={rowActions}
      title={tableTitle}
      pagination={pagination}
      pageChanged={pageChange}
      perPageChanged={perPageChange}
      localization={localization}
      paginationDisabled={paginationDisabled}
      errorText={errorText}
      options={options}
    />
  )
}

export default withTranslate(DataTable)
